module.exports = __webpack_public_path__ + "static/media/salesforce.48580aa1.png";